(() => {
  'use strict';
  const reveal = () => {
    if (!location.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (_) { return; }
    if (!target) return;
    const guide = target.closest('details.bexco-collection-guide');
    if (!guide || guide.open) return;
    guide.open = true;
    requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
  };
  window.addEventListener('hashchange',reveal);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',reveal,{once:true}); else reveal();
})();
